import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';

interface QuestionOverride {
  playerId?: string;
  teamId?: string;
  statType: string;
  value: number;
  originalValue?: number;
  reason?: string;
  createdAt: string;
  updatedAt: string;
}

interface GetQuestionOverridesResponse {
  questionId: string;
  overrideCount: number;
  overrides: QuestionOverride[];
}

export const getQuestionOverrides = async (
  questionId: string
): Promise<GetQuestionOverridesResponse> => {
  const response = await (apiClient as any).get(
    `/api/admin/live-scoring/question/${questionId}/overrides`
  );
  return response as GetQuestionOverridesResponse;
};

export const useGetQuestionOverridesQuery = (questionId: string | null) => {
  return useQuery({
    queryKey: ['live-scoring', 'question', questionId, 'overrides'],
    queryFn: () => getQuestionOverrides(questionId!),
    enabled: !!questionId,
  });
};
